import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ITablePagerOptions} from "./ITablePagerOptions";

@Component({
    selector: 'app-table-pager',
    templateUrl: './table-pager.component.html',
    styleUrl: './table-pager.component.scss'
})
export class TablePagerComponent {

    @Input({required: true}) pagerOptions: ITablePagerOptions;
    @Input() visiblePageCount: number = 5;
    @Output() pageChange = new EventEmitter<number>();

    /**
     * Populates page change
     * @param number
     */
    onPageChange(number: number): void {
        this.pageChange.next(number);
    }
}
